import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { mustBeArray } from "../../utils/lib";

const RebateRCTIErrorModal = ({ visible, handleModalClose, errors }) => {
  return (
    <Modal style={{ maxWidth: "650px" }} isOpen={visible}>
      <ModalHeader
        close={
          <span className="bold hand" onClick={handleModalClose}>
            X
          </span>
        }
      >
        Client Locations With Invalid Fields
      </ModalHeader>
      <ModalBody>
        <p>
          Please update the following locations before submitting the request.
          Alternatively, you can uncheck them and continue.
        </p>
        {errors && !_.isEmpty(mustBeArray(errors.invalidAbn)) && (
          <React.Fragment>
            <h6>Invalid ABN</h6>
            <ul>
              {mustBeArray(errors.invalidAbn).map((error, i) => {
                return <li key={i}>{error}</li>;
              })}
            </ul>
          </React.Fragment>
        )}
        {errors && !_.isEmpty(mustBeArray(errors.invalidAccountName)) && (
          <React.Fragment>
            <h6>Invalid Account Name</h6>
            <ul>
              {mustBeArray(errors.invalidAccountName).map((error, i) => {
                return <li key={i}>{error}</li>;
              })}
            </ul>
          </React.Fragment>
        )}
        {errors && !_.isEmpty(mustBeArray(errors.invalidCompanyName)) && (
          <React.Fragment>
            <h6>Invalid Company Name</h6>
            <ul>
              {mustBeArray(errors.invalidCompanyName).map((error, i) => {
                return <li key={i}>{error}</li>;
              })}
            </ul>
          </React.Fragment>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleModalClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default RebateRCTIErrorModal;
